import { CurrencyDisplayUtil } from './../../common/currency-display-util';
import { AmChartsService } from '@amcharts/amcharts3-angular';
import { SurvivalHorizonService } from './../../survival-horizon/survival-horizon.service';
import { DashboardEventService } from './../../dashboard/dashboard-event.service';
import { MetricSelection } from './../metric-selection';
import { Component, OnInit, Input, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { SuspenseBalanceMetric } from './suspense-balance-metric';
import { TrendMetric } from './../trend-metric/trend-metric';

@Component({
    selector: 'app-suspense-balance-metric',
    templateUrl: './suspense-balance-metric.component.html',
    styleUrls: ['./suspense-balance-metric.component.scss', './../trend-metric/trend-metric.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SuspenseBalanceMetricComponent implements OnInit, OnDestroy {
    @Input()
    suspenseBalanceMetric: SuspenseBalanceMetric;

    constructor(private amCharts: AmChartsService,
        private survivalHorizonService: SurvivalHorizonService,
        private dashboardEventService: DashboardEventService,
        private changeDetectorRef: ChangeDetectorRef) {

    }

    ngOnInit() {
        console.log(this.suspenseBalanceMetric);
    }

    ngOnDestroy() {
        this.changeDetectorRef.detach();
    }

    refreshMetric() {
        this.changeDetectorRef.markForCheck();
    }

    onHistory() {
        // this.dashboardEventService.metricSelectionSubject.next(
        //     new MetricSelection(this.throughputMetric.currency, this.throughputMetric.metricType, this.throughputMetric.name)
        // );
    }

    onIntraday() {
        this.dashboardEventService.metricSelectionSubject.next(
            new MetricSelection('SUSPENSE_BALANCE', this.suspenseBalanceMetric.currency,
                this.suspenseBalanceMetric.metricType, this.suspenseBalanceMetric.name, this.suspenseBalanceMetric)
        );
    }

    formatAmount(value: number): string {
        return CurrencyDisplayUtil.toShortNumber(value, 2);
    }

    lightMetricColor(suspenseBalanceMetric: SuspenseBalanceMetric) {
        if (suspenseBalanceMetric.initialized) {
            if (suspenseBalanceMetric.balance > 0) {
                return TrendMetric.C_900[4];
            } else {
                return TrendMetric.C_900[2];
            }
        }
    }
}
